import { memo } from 'react';
import { Link } from 'infrastructure/router';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { WebRoutes } from 'consts/enpoints/web';
import { SignIn as SignInLayout } from 'ui/layouts/SignIn';
import { SignIn } from "ui/forms/Auth";
import useLogin from './useLogin';

const Login = () => {
    const { error, login } = useLogin();

    return (
        <SignInLayout
            title='Sign in to Macropay'
        >
            {error && (
                <Alert severity='error' sx={{ mt: 2 }}>
                    {error}
                </Alert>
            )}
            <SignIn.Form
                onSubmit={login}
            >
                <Box
                    to={WebRoutes.Login.SendResetLink}
                    component={Link}
                    sx={{
                        ml: 'auto',
                        display: 'block',
                        width: 'fit-content'
                    }}
                >
                    Forgot password?
                </Box>
            </SignIn.Form>
        </SignInLayout>
    );
};

export default memo(Login);
